
import TradingBotStats from "@/models/TradingBotStats";
import { Component } from "vue-property-decorator";
import BaseAuthenticatedView from "@/views/BaseAuthenticatedView.vue";
import BotsActivityTable from "./components/BotsActivityTable.vue";
import { PercentIndicator } from "@/mixins/percentIndicatorMixin";
import Formatter from "@/mixins/formatterMixin";
import TradingViewTicker from "./components/TradingViewTicker.vue";
import MarketWithExchange from "@/models/MarketWithExchange";
import BotBalanceOverTimeChart from "./components/charts/individual-bot/BotBalanceOverTimeChart.vue";
import DateFormatter from "@/mixins/dateFormatterMixin";
import MarketSlot from "@/components/general/MarketSlot.vue";
import BalanceInUseDonutChart from "./components/charts/BalanceInUseDonutChart.vue";
import BotStatusIndicator from "./components/BotStatusInidcaor.vue";
import TooltipLabel from "@/components/general/TooltipLabel.vue";
import TooltipIcon from "@/components/general/TooltipIcon.vue";
import ExchangeMixin from "@/mixins/exchangeMixin";
import FunctionalityLimitationMixin from "@/mixins/functionalityLimitationMixin";
import StopLossField from "./components/stop-loss/StopLossField.vue";
import IndividualBotChartWrapper from "./components/charts/individual-bot/IndividualBotsChartWrapper.vue";
import SensitiveNumbersMixin from "@/mixins/sensitiveNumbersMixin";
import TimeFrameSelector from "./components/trading-bot-chips/TimeFrameSelector.vue";
import TradeModel from "@/models/Trade";

@Component({
  components: {
    BotsActivityTable,
    TradingViewTicker,
    BotBalanceOverTimeChart,
    MarketSlot,
    BalanceInUseDonutChart,
    IndividualBotLogsDialog: () =>
      import("./components/dialogs/IndividualBotLogsDialog.vue"),
    ArchiveBotDialog: () => import("./components/dialogs/ArchiveBotDialog.vue"),
    BotStatusIndicator,
    TooltipLabel,
    TooltipIcon,
    StopLossField,
    IndividualBotChartWrapper,
    TimeFrameSelector,
  },
  mixins: [
    PercentIndicator,
    Formatter,
    DateFormatter,
    ExchangeMixin,
    FunctionalityLimitationMixin,
    SensitiveNumbersMixin,
  ],
})
export default class BotDetails extends BaseAuthenticatedView {
  // 🗻 Table headers displayed in the "Open Orders" tab for all bots
  private openOrdersHeadersBot = [
    { text: "Created At", value: "createTime" },
    { text: "Expires In", value: "expireTime" },
    { text: "Market", value: "market" },
    { text: "Side", value: "side" },
    { text: "Type", value: "type" },
    { text: "Amount", value: "volume" },
    { text: "Price", value: "price" },
  ];

  // 🗻 Table headers displayed in the "Trade History" tab for all bots
  private tradeHistoryHeadersBot = [
    { text: "Date Executed", value: "date" },
    { text: "Market", value: "market" },
    { text: "Side", value: "type" },
    { text: "Price", value: "price" },
    { text: "Amount", value: "amount" },
    { text: "Exchange Fee", value: "fee" },
    { text: "Crypto/Stablecoin Ratio", value: "pRatio" },
    { text: "OBT Fee", value: "obt_fee" },
    { text: "Ending Balance", value: "balance" },
  ];

  // 🚩 Flag for whether the page is loading
  private isLoading: boolean = false;

  // 🚩 Flag for whether the dialog for archiving a bot should be shown
  private showArchiveBotDialog: boolean = false;

  // 🚩 Flag for whether the dialog that displays the bot logs should be shown
  private showBotLogsDialog: boolean = false;

  private tradeHistory: TradeModel[] = [];

  // 📦 Bot stats for the details page
  public get botStats(): TradingBotStats {
    const stats = this.$store.getters.getTradingBotStatsById(
      this.$route.params.id
    );
    if (stats == null) {
      this.$router.push("/my-portfolio");
    }
    return stats;
  }

  // 🚩 Flag for whether the balance in use chart is enabled based on the bot stats properties
  private get isBalanceInUseChartEnabled(): boolean {
    return (
      (this.botStats.trades_count > 0 && this.botStats.enabled) ||
      this.botStats.enabled === false
    );
  }

  // 📦 Exchange with market that should be displayed in the Ticker
  private get exchangeWithMarket(): MarketWithExchange {
    return new MarketWithExchange(this.botStats.market, this.botStats.exchange);
  }

  protected async mounted() {
    this.isLoading = true;
    this.tradeHistory = await this.$store.dispatch(
      "fetchTradeHistory",
      this.botStats.uid
    );
    this.isLoading = false;
  }
}
